export const projects = [
  {
    title: 'Vivid',
    description: 'A Solution to Manage Personal Finance',
    link: 'https://andersenlab.com/project-cases/personalized-finance-assistant-app',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Vivid.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Vivid.webp',
    },
  },
  {
    title: 'Paysera',
    description: 'An All-in-One Set of FinTech Solutions',
    link: 'https://andersenlab.com/project-cases/comprehensive-set-of-finance-it-solutions',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Paysera.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Paysera.webp',
    },
  },
  {
    title: 'Centtrip',
    description: 'A FinTech Tool for Treasury Management',
    link: 'https://andersenlab.com/project-cases/comprehensive-set-of-finance-apps',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Centtrip.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Centtrip.webp',
    },
  },
  {
    title: 'DECTA',
    description: 'A Finance Solution for Online Payments and Card Issuance',
    link: 'https://andersenlab.com/project-cases/payment-and-acquiring-system',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Decta.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Decta.webp',
    },
  },
  {
    title: 'Leonteq',
    description: 'A Finance Solution for Investment Management and Analysis',
    link: 'https://andersenlab.com/project-cases/investment-solution-to-hedge-risks',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Leonteq.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Leonteq.webp',
    },
  },
  {
    title: 'GBank',
    description: 'A Finance Tool Built as a Mobile Bank',
    link: 'https://andersenlab.com/project-cases/mobile-banking-app-for-small-businesses',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/G-bank.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/G-bank.webp',
    },
  },
  {
    title: 'Finitera',
    description: 'A FinTech Tool to Provide and Manage Short-Term Loans',
    link: 'https://andersenlab.com/project-cases/system-to-calculate-loans',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Finitera.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Finitera.webp',
    },
  },
  {
    title: 'Shieldpay',
    description: 'A Mass Payout Platform',
    link: 'https://andersenlab.com/project-cases/fintech-solution-payout-system',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Shieldplay.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Shieldplay.webp',
    },
  },
  {
    title: 'Luno',
    description: 'A FinTech Project to Build a Digital Crypto Wallet',
    link: 'https://andersenlab.com/project-cases/cryptocurrency-wallet-for-digital-assets',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Luno.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Luno.webp',
    },
  },
  {
    title: 'Project 1',
    description: 'A Finance Solution to Control and Facilitate Loan Issuing',
    link: 'https://andersenlab.com/project-cases/credit-conveyor-software-assessment-decision-making',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-1.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-1.webp',
    },
  },
  {
    title: 'Project 2',
    description: 'A FinTech Tool to Automate Compliance and Risk Management',
    link: 'https://andersenlab.com/project-cases/tool-for-compliance-control',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-2.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-2.webp',
    },
  },
  {
    title: 'Project 3',
    description: 'A Finance Mobile Application for an Insurance Company',
    link: 'https://andersenlab.com/project-cases/mobile-insurance-app',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-3.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-3.webp',
    },
  },
  {
    title: 'Project 4',
    description: 'A Personal Finance App',
    link: 'https://andersenlab.com/project-cases/personal-finance-assistant-app',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-4.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-4.webp',
    },
  },
  {
    title: 'Project 5',
    description: 'Developing an API Strategy for the Insurance Industry',
    link: 'https://andersenlab.com/project-cases/andersen-discovery-phase-api-insurance-assistance',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-5.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-5.webp',
    },
  },
  {
    title: 'Project 6',
    description: 'An Advanced BNPL Solution for an eCommerce Business',
    link: 'https://andersenlab.com/project-cases/bnpl-solution-for-eu-company',
    img: {
      desktop:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-6.jpg',
      desktop_webp:
        'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/fintech-week/projects/Project-6.webp',
    },
  },
];
